const terms = {
  title: 'उपयोग की शर्तें',
  description: 'Plannely ऐप और वेबसाइट के उपयोग की शर्तें: आपका खाता, सदस्यताएँ, आपकी सामग्री और सेवा के उपयोग के नियम।',
  effectiveLabel: 'प्रभावी तिथि:',
  effectiveDate: '5 नवंबर 2026',
  appLabel: 'ऐप:',
  privacyPhrases: ['गोपनीयता नीति'],
  sections: [
    {
      title: 'इन शर्तों से सहमति',
      body: [
        'ये उपयोग की शर्तें ("शर्तें") Plannely मोबाइल ऐप और वेबसाइट https://plannely.app (एक साथ, "सेवा") के आपके उपयोग पर लागू होती हैं। सेवा SEOTIV ("हम") द्वारा प्रदान की जाती है।',
        'खाता बनाकर या सेवा का उपयोग करके आप इन शर्तों से सहमत होते हैं। यदि आप सहमत नहीं हैं, तो कृपया सेवा का उपयोग न करें। हमारी गोपनीयता नीति https://plannely.app/privacy-policy पर उपलब्ध है, जो बताती है कि हम व्यक्तिगत डेटा को कैसे संभालते हैं और सेवा के संचालन पर लागू होती है।',
      ],
    },
    {
      title: 'सेवा',
      body: [
        'Plannely एक व्यक्तिगत प्लानर है। प्लेटफ़ॉर्म, संस्करण और प्लान के अनुसार इसमें कार्य, श्रेणियाँ, आदतें, रिमाइंडर, कैलेंडर दृश्य, फ़ोकस और वर्कआउट टूल तथा आपके उपकरणों के बीच सिंक्रनाइज़ेशन शामिल हो सकते हैं।',
        'सेवा के विकास के साथ हम सुविधाएँ जोड़, बदल या हटा सकते हैं। यदि किसी बदलाव से वह सशुल्क सुविधा काफ़ी कम हो जाती है जिसके लिए आप अभी भुगतान कर रहे हैं, तो हम ऐप या किसी अन्य उपयुक्त माध्यम से उचित समय पहले सूचित करने का प्रयास करेंगे।',
      ],
    },
    {
      title: 'आपका खाता',
      body: [
        'आप ऐप में उपलब्ध किसी तरीके, जैसे Google या Apple, से साइन इन करते हैं। उस खाते और आपके उपकरणों तक पहुँच को सुरक्षित रखने तथा आपके Plannely खाते में होने वाली गतिविधि की ज़िम्मेदारी आपकी है। यदि आपको लगता है कि किसी ने बिना अनुमति आपके खाते तक पहुँच बनाई है, तो तुरंत support@plannely.app पर हमें बताएँ।',
        'कृपया सुनिश्चित करें कि आपकी दी गई जानकारी सही है। सेवा का उपयोग केवल उसी तरह करें जैसा आप पर लागू कानून अनुमति देते हैं।',
      ],
    },
    {
      title: 'बच्चे और नाबालिग',
      body: [
        'यदि आप उस आयु तक नहीं पहुँचे हैं जिसमें आपके निवास स्थान पर बाध्यकारी अनुबंध किया जा सकता है, तो आप सेवा का उपयोग केवल माता-पिता या कानूनी अभिभावक की अनुमति और सहभागिता से कर सकते हैं, जो आपकी ओर से इन शर्तों को स्वीकार करते हैं। हमारी गोपनीयता नीति की धारा 14 बताती है कि हम बच्चों के डेटा को कैसे संभालते हैं।',
      ],
    },
    {
      title: 'निःशुल्क और सशुल्क प्लान',
      body: [
        'Plannely उपयोग सीमाओं वाला निःशुल्क प्लान और अधिक सीमाओं या अतिरिक्त सुविधाओं वाली वैकल्पिक सशुल्क सदस्यताएँ प्रदान करता है। वर्तमान सीमाएँ और कीमतें ऐप में दिखाई जाती हैं और बदल सकती हैं। निःशुल्क प्लान में कार्य, पूरे हो चुके कार्यों सहित, तब तक सीमा में गिने जाते हैं जब तक आप उन्हें हटा नहीं देते।',
        'सदस्यताएँ Apple या Google Play द्वारा उस खाते के माध्यम से बेची और बिल की जाती हैं जिससे आप खरीदारी करते हैं। स्टोर के नियमों के साथ निम्नलिखित लागू होता है:',
        [
          'जब तक आप वर्तमान अवधि समाप्त होने से कम से कम 24 घंटे पहले या स्टोर द्वारा तय समय में रद्द नहीं करते, सदस्यता उस समय की कीमत पर उसी अवधि के लिए अपने आप नवीनीकृत होती है।',
          'यदि निःशुल्क ट्रायल दिया जाता है, तो समय पर रद्द न करने पर उसके अंत में वह सशुल्क सदस्यता में बदल जाता है। कीमत और ट्रायल की अवधि खरीदारी की पुष्टि से पहले दिखाई जाती है।',
          'आप अपने Apple या Google Play खाते में सदस्यता प्रबंधित या रद्द करते हैं। ऐप या अपना Plannely खाता हटाने से सदस्यता रद्द नहीं होती।',
          'रिफ़ंड स्टोर अपनी नीतियों के अनुसार संभालता है। हम स्टोर के भुगतान संसाधित नहीं करते और आपके कार्ड का पूरा विवरण प्राप्त नहीं करते।',
        ],
        'सदस्यता समाप्त होने पर आपका खाता निःशुल्क प्लान पर लौट आता है। इस कारण आपका डेटा नहीं हटाया जाता, लेकिन निःशुल्क सीमाओं से अधिक सुविधाएँ और सामग्री, जैसे अतिरिक्त आदतें, दोबारा सदस्यता लेने तक उपलब्ध नहीं हो सकतीं।',
      ],
    },
    {
      title: 'आपकी सामग्री',
      body: [
        'सेवा में आपके बनाए कार्यों, नोट्स, आदतों, वर्कआउट और अन्य सामग्री ("आपकी सामग्री") के सभी अधिकार आपके पास रहते हैं। आप हमें आपकी सामग्री को केवल उतनी सीमा तक संग्रहीत, संसाधित, कॉपी और प्रेषित करने का सीमित, गैर-अनन्य, विश्वव्यापी लाइसेंस देते हैं जितना आपके लिए सेवा को चलाने, सुरक्षित रखने और सहायता देने के लिए आवश्यक है। हम आपकी सामग्री का उपयोग विज्ञापन के लिए नहीं करते और उसे बेचते नहीं हैं।',
        'आपकी सामग्री और उसका उपयोग करने के अधिकार की ज़िम्मेदारी आपकी है। जो कुछ भी आपके लिए अत्यंत महत्वपूर्ण है, उसकी अपनी प्रति रखें।',
        'यदि आप किसी वर्कआउट प्रोग्राम का शेयर लिंक बनाते हैं, तो लिंक की अवधि समाप्त होने या आपके उसे रद्द करने तक लिंक रखने वाला कोई भी व्यक्ति उस प्रोग्राम को देख और कॉपी कर सकता है। लिंक केवल भरोसेमंद लोगों के साथ साझा करें और साझा की जाने वाली सामग्री में निजी जानकारी न डालें।',
      ],
    },
    {
      title: 'स्वीकार्य उपयोग',
      body: [
        'सेवा का उपयोग करते समय आप सहमत होते हैं कि आप:',
        [
          'कानून या दूसरों के अधिकारों का उल्लंघन नहीं करेंगे;',
          'शेयर लिंक सहित किसी भी तरीके से अवैध, हानिकारक या अपमानजनक सामग्री संग्रहीत या साझा नहीं करेंगे;',
          'सेवा, अन्य खातों या हमारे सिस्टम तक अनधिकृत पहुँच प्राप्त नहीं करेंगे या इसका प्रयास नहीं करेंगे;',
          'सेवा में बाधा नहीं डालेंगे, उस पर अधिक भार नहीं डालेंगे, या प्लान की सीमाओं और अन्य तकनीकी प्रतिबंधों को दरकिनार नहीं करेंगे;',
          'सेवा की रिवर्स इंजीनियरिंग नहीं करेंगे, सिवाय इसके कि कानून इस प्रतिबंध के बावजूद इसकी अनुमति दे;',
          'हमारी लिखित अनुमति के बिना स्वचालित तरीकों से सेवा से डेटा नहीं निकालेंगे;',
          'हमारी लिखित अनुमति के बिना सेवा को दोबारा नहीं बेचेंगे या व्यावसायिक रूप से पुनर्वितरित नहीं करेंगे।',
        ],
      ],
    },
    {
      title: 'रिमाइंडर और उपलब्धता',
      body: [
        'हम सेवा को भरोसेमंद रखने का प्रयास करते हैं, लेकिन रिमाइंडर और सिंक आपके उपकरण, उसकी सेटिंग्स, आपके नेटवर्क और Apple तथा Google जैसी तृतीय-पक्ष सेवाओं पर निर्भर करते हैं। सूचनाएँ देर से आ सकती हैं या नहीं भी आ सकतीं। जहाँ सूचना छूटने से नुकसान या गंभीर हानि हो सकती है, जैसे दवा लेना, वहाँ सेवा को एकमात्र रिमाइंडर न बनाएँ।',
        'रखरखाव, अपडेट या हमारे नियंत्रण से बाहर की घटनाओं के कारण सेवा कभी-कभी अनुपलब्ध हो सकती है।',
      ],
    },
    {
      title: 'स्वास्थ्य और वर्कआउट',
      body: [
        'वर्कआउट, फ़ोकस और आदत संबंधी सुविधाएँ स्व-प्रबंधन के सामान्य टूल हैं। ये चिकित्सा सलाह, निदान या उपचार नहीं हैं। व्यायाम शुरू करने या बदलने से पहले, विशेष रूप से यदि आपको कोई स्वास्थ्य समस्या है, योग्य स्वास्थ्य विशेषज्ञ से बात करें। दर्द, चक्कर या असुविधा महसूस होने पर व्यायाम रोक दें। कानून द्वारा अनुमत सीमा तक, आप इन सुविधाओं का उपयोग अपने जोखिम पर करते हैं।',
      ],
    },
    {
      title: 'हमारी बौद्धिक संपदा',
      body: [
        'सेवा, जिसमें उसका सॉफ़्टवेयर, डिज़ाइन, नाम और लोगो शामिल हैं, हमारी या हमारे लाइसेंसदाताओं की है और बौद्धिक संपदा कानूनों से सुरक्षित है। हम आपको इन शर्तों के अनुसार सेवा को उसके निर्धारित उद्देश्य के लिए उपयोग करने का व्यक्तिगत, सीमित, गैर-अनन्य, अहस्तांतरणीय और रद्द करने योग्य लाइसेंस देते हैं। आपकी सामग्री आपकी ही रहती है।',
        'यदि आप हमें फ़ीडबैक या विचार भेजते हैं, तो हम आपके प्रति किसी दायित्व के बिना उनका उपयोग कर सकते हैं।',
      ],
    },
    {
      title: 'तृतीय-पक्ष सेवाएँ',
      body: [
        'सेवा साइन-इन, भुगतान, सूचनाओं और होस्टिंग जैसे कार्यों के लिए तृतीय पक्षों पर निर्भर है। उनकी प्रदान की गई सेवाओं पर उनकी अपनी शर्तें और गोपनीयता नीतियाँ लागू होती हैं। हम उन तृतीय-पक्ष सेवाओं की उपलब्धता या कार्यों के लिए ज़िम्मेदार नहीं हैं जिन्हें हम नियंत्रित नहीं करते।',
      ],
    },
    {
      title: 'सेवा का उपयोग समाप्त करना',
      body: [
        'आप किसी भी समय सेवा का उपयोग बंद कर सकते हैं और ऐप में या support@plannely.app पर ईमेल करके अपना खाता हटा सकते हैं। खाता हटाने का विवरण हमारी गोपनीयता नीति में है। स्टोर की किसी भी सदस्यता को अलग से रद्द करना याद रखें।',
        'यदि आप इन शर्तों का गंभीर या बार-बार उल्लंघन करते हैं, आपके उपयोग से सेवा या दूसरों को जोखिम होता है, या कानून इसकी माँग करता है, तो हम खाते को निलंबित या बंद कर सकते हैं। जहाँ उचित और अनुमत हो, हम कारण बताएँगे और समस्या ठीक करने का अवसर देंगे। यदि हम सेवा बंद करते हैं, तो उचित समय पहले सूचित करने का प्रयास करेंगे।',
      ],
    },
    {
      title: 'वारंटी का अस्वीकरण',
      body: [
        'कानून द्वारा अनुमत अधिकतम सीमा तक, सेवा "जैसी है" और "जैसी उपलब्ध है" के आधार पर प्रदान की जाती है। हम यह वादा नहीं करते कि वह बिना रुकावट या त्रुटि के चलेगी, किसी विशेष उद्देश्य के लिए उपयुक्त होगी, या डेटा कभी नहीं खोएगा। इन शर्तों में कुछ भी उन वारंटियों या उपभोक्ता अधिकारों को सीमित नहीं करता जिन्हें आप पर लागू कानून के तहत सीमित नहीं किया जा सकता।',
      ],
    },
    {
      title: 'दायित्व की सीमा',
      body: [
        'कानून द्वारा अनुमत अधिकतम सीमा तक, हम अप्रत्यक्ष, आकस्मिक, विशेष या परिणामी क्षति, या खोए हुए लाभ, डेटा की हानि या छूटी हुई घटनाओं के लिए उत्तरदायी नहीं हैं। सशुल्क प्लान के लिए, सेवा से संबंधित किसी भी दावे पर हमारा कुल दायित्व उस राशि तक सीमित है जो आपने दावे का कारण बनी घटना से पहले के 12 महीनों में सेवा के लिए चुकाई थी। निःशुल्क प्लान के लिए, यह 50 अमेरिकी डॉलर के समतुल्य राशि तक सीमित है।',
        'ये सीमाएँ उस दायित्व पर लागू नहीं होतीं जिसे कानून के तहत बाहर या सीमित नहीं किया जा सकता, जैसे धोखाधड़ी, जानबूझकर किया गया गलत कार्य, या जहाँ कानून ऐसा प्रावधान करता हो वहाँ लापरवाही से हुई मृत्यु या व्यक्तिगत चोट।',
      ],
    },
    {
      title: 'Apple App Store से डाउनलोड किए गए ऐप',
      body: [
        'यदि आपने Plannely को Apple App Store से डाउनलोड किया है, तो ये अतिरिक्त शर्तें लागू होती हैं:',
        [
          'ये शर्तें आपके और SEOTIV के बीच हैं, Apple के साथ नहीं। ऐप और उसकी सामग्री के लिए केवल SEOTIV ज़िम्मेदार है, Apple नहीं।',
          'आपका लाइसेंस आपके स्वामित्व या नियंत्रण वाले Apple-ब्रांड उपकरणों पर ऐप के उपयोग तक सीमित है, जैसा Apple मीडिया सेवा नियम और शर्तों के उपयोग नियम अनुमति देते हैं।',
          'Apple का ऐप के लिए रखरखाव या सहायता प्रदान करने का कोई दायित्व नहीं है।',
          'यदि ऐप किसी लागू वारंटी के अनुरूप नहीं है, तो आप Apple को सूचित कर सकते हैं और Apple खरीद मूल्य, यदि कोई हो, वापस करेगा। कानून द्वारा अनुमत अधिकतम सीमा तक, ऐप के संबंध में Apple का कोई अन्य वारंटी दायित्व नहीं है।',
          'ऐप या उसके उपयोग से संबंधित दावों, जिनमें उत्पाद दायित्व, कानूनी या नियामक अनुपालन, उपभोक्ता संरक्षण या गोपनीयता के दावे शामिल हैं, को संभालने की ज़िम्मेदारी Apple की नहीं है।',
          'ऐप या उसके उपयोग से बौद्धिक संपदा अधिकारों के उल्लंघन के किसी तृतीय-पक्ष दावे की जाँच, बचाव, निपटान या निस्तारण की ज़िम्मेदारी Apple की नहीं है।',
          'आप पुष्टि करते हैं कि आप ऐसे देश में नहीं हैं जिस पर अमेरिकी सरकार का प्रतिबंध लागू है या जिसे "आतंकवाद समर्थक" देश घोषित किया गया है, और आप अमेरिकी सरकार की निषिद्ध या प्रतिबंधित पक्षों की किसी सूची में नहीं हैं।',
          'ऐप का उपयोग करते समय आपको लागू तृतीय-पक्ष शर्तों का पालन करना होगा।',
          'Apple और उसकी सहायक कंपनियाँ इन शर्तों की तृतीय-पक्ष लाभार्थी हैं और इन्हें आपके विरुद्ध लागू कर सकती हैं।',
        ],
      ],
    },
    {
      title: 'इन शर्तों में बदलाव',
      body: [
        'सेवा या कानून में बदलाव होने पर हम इन शर्तों को अपडेट कर सकते हैं। नवीनतम संस्करण अपनी प्रभावी तिथि के साथ हमेशा https://plannely.app/terms पर प्रकाशित रहता है। महत्वपूर्ण बदलाव होने पर हम ऐप या किसी अन्य उपयुक्त माध्यम से पहले सूचित करने का प्रयास करेंगे। बदलाव प्रभावी होने के बाद सेवा का उपयोग जारी रखने पर आप अपडेट की गई शर्तों को स्वीकार करते हैं। यदि आप सहमत नहीं हैं, तो सेवा का उपयोग बंद करें और अपना खाता हटा दें।',
      ],
    },
    {
      title: 'लागू कानून और विवाद',
      body: [
        'कृपया पहले हमसे संपर्क करें ताकि हम किसी भी समस्या को अनौपचारिक रूप से हल करने का प्रयास कर सकें। ये शर्तें कानूनों के टकराव के नियमों की परवाह किए बिना उस देश के कानूनों से शासित हैं जहाँ SEOTIV स्थापित है। इससे आपके निवास के देश के उपभोक्ता कानूनों के तहत मिलने वाला कोई अनिवार्य संरक्षण समाप्त नहीं होता, जिसमें उन कानूनों के तहत उपलब्ध अदालतों में दावा करने का आपका अधिकार भी शामिल है।',
        'यदि इन शर्तों का कोई भाग लागू करने योग्य नहीं पाया जाता, तो शेष भाग लागू रहते हैं। यदि हम किसी प्रावधान को तुरंत लागू नहीं करते, तो हम उसे बाद में लागू करने का अधिकार नहीं छोड़ते। आप हमारी सहमति के बिना इन शर्तों के तहत अपने अधिकार हस्तांतरित नहीं कर सकते। हम आपके अधिकारों को कम किए बिना सेवा के पुनर्गठन या बिक्री के हिस्से के रूप में अपने अधिकार हस्तांतरित कर सकते हैं।',
        'हम आपकी सुविधा के लिए इन शर्तों के अनुवाद उपलब्ध कराते हैं। यदि कोई अनुवाद अंग्रेज़ी संस्करण से भिन्न है, तो अंग्रेज़ी संस्करण मान्य होगा, जब तक कि आपके देश का कानून कुछ और न कहे।',
      ],
    },
    {
      title: 'संपर्क',
      body: [
        'यदि इन शर्तों के बारे में आपके कोई प्रश्न हैं, तो हमें support@plannely.app पर लिखें।',
      ],
    },
  ],
};

export default terms;
